import React, { useRef, useEffect } from 'react';
import 'prop-types';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".Spinner-module_Arc__2qplK {\r\n  stroke-dasharray: 314.15%;\r\n  stroke-dashoffset: 250%;\r\n  animation: Spinner-module_dashSize__1yoxn 1.5s ease-in infinite alternate;\r\n}\r\n\r\n.Spinner-module_Spinner__3tZ2J {\r\n  animation: Spinner-module_spin__1cZ94 0.8s linear infinite;\r\n  height: 3em;\r\n  width: 3em;\r\n}\r\n\r\n@keyframes Spinner-module_dashSize__1yoxn {\r\n  0%   { stroke-dashoffset: 280%; }\r\n  100% { stroke-dashoffset: 0;    }\r\n}\r\n\r\n@keyframes Spinner-module_spin__1cZ94 {\r\n  0%   { transform: rotate(0deg); }\r\n  100% { transform: rotate(360deg);    }\r\n}";
var styles = { "Arc": "Spinner-module_Arc__2qplK", "dashSize": "Spinner-module_dashSize__1yoxn", "Spinner": "Spinner-module_Spinner__3tZ2J", "spin": "Spinner-module_spin__1cZ94" };
styleInject(css);

var Spinner = (function (props) {
  return React.createElement(
    'svg',
    { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 179.834 179.834', preserveAspectRatio: 'xMidYMid meet', className: styles.Spinner + (props.className ? ' ' + props.className : '') },
    React.createElement(
      'g',
      { fill: 'none', stroke: 'currentColor', transform: 'translate(-17.281 -51.977)' },
      React.createElement('circle', { cx: '107.199', cy: '141.894', r: '87.417', strokeWidth: '5', className: styles.Arc }),
      React.createElement('circle', { cx: '107.199', cy: '141.894', r: '87.417', strokeWidth: '2' })
    )
  );
});

var css$1 = ".Alert-module_Alert__kc66G {\r\n  height: 4em;\r\n  width: 4em;\r\n}";
var styles$1 = { "Alert": "Alert-module_Alert__kc66G" };
styleInject(css$1);

var Alert = (function (props) {
  return React.createElement(
    'svg',
    { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 83.367 73.195', fill: 'currentColor', preserveAspectRatio: 'xMidYMid meet', className: styles$1.Alert + (props.className ? ' ' + props.className : '') },
    React.createElement('path', { d: 'M41.598.001a3.75 3.75 0 00-3.162 1.874L19.47 34.723.508 67.57c-1.443 2.499.36 5.623 3.246 5.624h75.86c2.885-.002 4.688-3.125 3.245-5.624L63.897 34.723 44.932 1.875A3.75 3.75 0 0041.598.001zm-.003 18.634c1.442-.031 2.89.846 3.428 2.234.977 2.495.316 5.19.094 7.766l-2.781 25.028H41.04c-1.046-9.718-2.132-19.432-3.151-29.152-.273-2.05.284-4.547 2.3-5.528a3.235 3.235 0 011.405-.348zm.088 40.62a3.765 3.765 0 013.765 3.764 3.765 3.765 0 01-3.765 3.764 3.765 3.765 0 01-3.764-3.764 3.765 3.765 0 013.764-3.764z' })
  );
});

var css$2 = "/* add css styles here (optional) */\r\n\r\n.styles_OverlayParent__P9_Zi {\r\n  display: -ms-grid;\r\n  display: grid;\r\n  -ms-grid-columns: 1fr;\r\n  -ms-grid-rows: 1fr;\r\n  grid-template-columns: 1fr;\r\n  grid-template-rows: 1fr;\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.styles_GridOverlap__4Kc7A {\r\n  -ms-grid-column: 1;\r\n  -ms-grid-row: 1; \r\n  grid-column: 1/1;\r\n  grid-row: 1/1;\r\n}\r\n\r\n.styles_GridCenterInCell__i_wCg {\r\n  -ms-grid-row-align: center;\r\n  -ms-grid-column-align: center;\r\n  align-self: center;\r\n  justify-self: center;\r\n}\r\n\r\n.styles_Overlay__1I7hU {\r\n  -ms-grid-column: 1;\r\n  -ms-grid-row: 1;\r\n  grid-column: 1/1;\r\n  grid-row: 1/1;\r\n  display: -ms-grid;\r\n  display: grid;\r\n  -ms-grid-columns: 1fr auto 1fr;\r\n  -ms-grid-rows: 1fr auto 1fr;\r\n  grid-template-columns: 1fr auto 1fr;\r\n  grid-template-rows: 1fr auto 1fr;\r\n}\r\n\r\n.styles_NoPointerEvents__3qOU2 {\r\n  pointer-events: none;\r\n}\r\n\r\n.styles_HiddenOverlay__KWE8u {\r\n  visibility: hidden;\r\n  opacity: 0;\r\n  transition: visibility 0s 1s, opacity 1s ease;\r\n}\r\n\r\n.styles_ShownOverlay__9gDZV {\r\n  visibility: visible;\r\n  opacity: 1;\r\n  transition: opacity 1s ease;\r\n}\r\n\r\n.styles_AlertContainer__12VJk {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.styles_RetryButton__1eW27 {\r\n  font-weight: 900;\r\n  font-size: 0.8rem;\r\n  -ms-grid-column: 1;\r\n  -ms-grid-row: 1;\r\n  grid-column: 1/1;\r\n  grid-row: 1/1;\r\n  display: -ms-grid;\r\n  display: grid;\r\n  -ms-grid-columns: 1fr;\r\n  -ms-grid-rows: 1fr;\r\n  grid-template-columns: 1fr;\r\n  grid-template-rows: 1fr;\r\n  width: 5.5rem;\r\n  cursor: pointer;\r\n  -webkit-touch-callout: none; /* iOS Safari */\r\n    -webkit-user-select: none; /* Safari */\r\n     -khtml-user-select: none; /* Konqueror HTML */\r\n       -moz-user-select: none; /* Old versions of Firefox */\r\n        -ms-user-select: none; /* Internet Explorer/Edge */\r\n            user-select: none; /* Non-prefixed version, currently supported by Chrome, Opera and Firefox */\r\n}\r\n\r\n.styles_ColorClass__vlmM- {\r\n  background-color: rgba(255, 255, 255, 0.8);\r\n  color: black;\r\n}\r\n\r\n.styles_ErrorColorClass__1ddfu {\r\n  color: red;\r\n}\r\n\r\n.styles_GridCentered__8HUrr {\r\n  -ms-grid-column: 2;\r\n  -ms-grid-row: 2; \r\n  grid-column: 2/2;\r\n  grid-row: 2/2;\r\n  -ms-grid-row-align: center;\r\n  -ms-grid-column-align: center;\r\n  align-self: center;\r\n  justify-self: center;\r\n}";
var styles$2 = { "OverlayParent": "styles_OverlayParent__P9_Zi", "GridOverlap": "styles_GridOverlap__4Kc7A", "GridCenterInCell": "styles_GridCenterInCell__i_wCg", "Overlay": "styles_Overlay__1I7hU", "NoPointerEvents": "styles_NoPointerEvents__3qOU2", "HiddenOverlay": "styles_HiddenOverlay__KWE8u", "ShownOverlay": "styles_ShownOverlay__9gDZV", "AlertContainer": "styles_AlertContainer__12VJk", "RetryButton": "styles_RetryButton__1eW27", "ColorClass": "styles_ColorClass__vlmM-", "ErrorColorClass": "styles_ErrorColorClass__1ddfu", "GridCentered": "styles_GridCentered__8HUrr" };
styleInject(css$2);

var css$3 = ".TimedButton-module_TimedButton__21EEh {\r\n  height: 2rem;\r\n  width: 5.5rem;\r\n}\r\n\r\n.TimedButton-module_TimerStroke__2aVB2 {\r\n  stroke-dasharray: 490;\r\n  stroke-dashoffset: 0;\r\n  animation-name: TimedButton-module_dashSize__3AR2-;\r\n  animation-timing-function: linear;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n@keyframes TimedButton-module_dashSize__3AR2- {\r\n  0%   { stroke-dashoffset: 0;   }\r\n  100% { stroke-dashoffset: 490; }\r\n}\r\n";
var styles$3 = { "TimedButton": "TimedButton-module_TimedButton__21EEh", "TimerStroke": "TimedButton-module_TimerStroke__2aVB2", "dashSize": "TimedButton-module_dashSize__3AR2-" };
styleInject(css$3);

var TimedButton = (function (props) {
  return React.createElement(
    'svg',
    { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 194.982 70.631', className: styles$3.TimedButton, onAnimationEnd: props.onAnimationEnd },
    React.createElement(
      'g',
      { fill: 'none', stroke: 'currentColor', strokeLinejoin: 'round' },
      React.createElement('path', { d: 'M16.621 2.5c-3.453 0-6.703 1.032-9.35 3.074C4.625 7.616 2.5 10.991 2.5 14.906v40.819c0 3.915 2.125 7.29 4.771 9.332 2.647 2.042 5.897 3.073 9.35 3.074H178.357c3.454 0 6.704-1.032 9.352-3.074 2.648-2.042 4.774-5.416 4.773-9.332V14.904c0-3.915-2.126-7.288-4.773-9.33-2.648-2.042-5.898-3.074-9.352-3.074H16.621z' }),
      React.createElement('path', {
        className: styles$3.TimerStroke,
        style: {
          animationDuration: props.timeout ? props.timeout + 's' : "5s",
          animationPlayState: props.manualRetry ? "paused" : "running"
        },
        strokeWidth: '5',
        d: 'M97.489 2.5H16.621c-3.453 0-6.703 1.032-9.35 3.074C4.625 7.616 2.5 10.991 2.5 14.906v40.819c0 3.915 2.125 7.29 4.771 9.332 2.647 2.042 5.897 3.073 9.35 3.074H178.357c3.454 0 6.704-1.032 9.352-3.074 2.648-2.042 4.774-5.416 4.773-9.332V14.904c0-3.915-2.126-7.288-4.773-9.33-2.648-2.042-5.898-3.074-9.352-3.074H97.489z'
      })
    )
  );
});

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var Timer = function () {
    function Timer(callback, delay) {
        var _this = this;

        classCallCheck(this, Timer);
        this.id = null;
        this.active = false;

        this.active = true;
        var wrap = function wrap() {
            _this.id = null;
            _this.active = false;
            callback();
        };
        this.id = setTimeout(wrap.bind(this), delay * 1000);
    }

    createClass(Timer, [{
        key: "stop",
        value: function stop() {
            clearTimeout(this.id);
            this.active = false;
            this.id = null;
        }
    }]);
    return Timer;
}();

var index = (function (props) {
  var timer = useRef();
  useEffect(function () {
    if (props.error && !props.loading && props.silent && props.retryEnabled && props.onRetry) {
      if (!timer.current || !timer.current.active) {
        timer.current = new Timer(props.onRetry, props.timeout ? props.timeout : 5);
      }
    } else {
      if (timer.current && timer.current.active) {
        timer.current.stop();
      }
    }
  }, [props.error, props.loading, props.silent, props.retryEnabled, props.onRetry]);
  useEffect(function () {
    return function () {
      if (timer.current && timer.current.active) {
        timer.current.stop();
      }
    };
  }, []);
  return React.createElement(
    'div',
    { className: props.className },
    React.createElement(
      'div',
      { className: styles$2.OverlayParent },
      React.createElement(
        'div',
        { className: styles$2.GridOverlap + ' ' + (!props.loading && !props.error ? null : styles$2.NoPointerEvents) },
        props.children
      ),
      React.createElement(
        'div',
        { className: styles$2.Overlay + ' ' + (props.colorClass ? props.colorClass : styles$2.ColorClass) + ' ' + (!props.loading && !props.error ? styles$2.HiddenOverlay : styles$2.ShownOverlay) },
        props.loading || props.error && props.silent && props.retryEnabled && props.onRetry ? props.spinnerIcon ? React.createElement(
          'div',
          { className: styles$2.GridCentered },
          props.spinnerIcon
        ) : React.createElement(Spinner, { className: styles$2.GridCentered }) : props.error ? React.createElement(
          'div',
          { className: styles$2.GridCentered + ' ' + styles$2.AlertContainer + ' ' + (props.errorColorClass ? props.errorColorClass : styles$2.ErrorColorClass) },
          props.alertIcon ? props.alertIcon : React.createElement(Alert, null),
          props.retryEnabled && props.onRetry && !props.silent ? React.createElement(
            'div',
            { onClick: props.onRetry, className: styles$2.RetryButton },
            React.createElement(
              'div',
              { className: styles$2.GridOverlap + ' ' + styles$2.GridCenterInCell },
              React.createElement(TimedButton, { onAnimationEnd: props.onRetry, timeout: props.timeout, manualRetry: props.manualRetry })
            ),
            React.createElement(
              'div',
              { className: styles$2.GridOverlap + ' ' + styles$2.GridCenterInCell },
              props.retryText ? props.retryText : 'Retry'
            )
          ) : null
        ) : null
      )
    )
  );
});

export default index;
//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ../dist/index.es.js
// module id = 20
// module chunks = 0